export default __webpack_public_path__ + "static/media/tamal.b1a0151b.png";